import { Box, Grid, Typography } from '@mui/material'

export const SectionBreak = ({ children }) => (
  <Box sx={{ marginBottom: { xs: '24px', sm: '32px' } }}>
    {children}
  </Box>
)

export const ElementBreak = ({ children }) => (
  <Grid container item sx={{ marginBottom: { xs: '16px', sm: '20px' } }}>
    {children}
  </Grid>
)

export const Heading = ({ children, ...props }) => (
  <Typography
    fontSize={{ xs: '16px', sm: '18px' }}
    color="#192A3E"
    fontWeight={700}
    sx={{ marginBottom: { xs: '12px', sm: '16px' } }}
    {...props}
  >
    {children}
  </Typography>
)
